"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_MARK_PRE_DELAY = exports.START_MARK_POST_DELAY = exports.EXECUTION_MEASUREMENT_PRE_DELAY = exports.EXECUTION_MEASUREMENT_POST_DELAY = exports.END_MARK_PRE_DELAY = exports.END_MARK_POST_DELAY = void 0;
const START_MARK_PRE_DELAY = exports.START_MARK_PRE_DELAY = 'embed-script-start-pre-delay';
const END_MARK_PRE_DELAY = exports.END_MARK_PRE_DELAY = 'embed-script-end-pre-delay';
const START_MARK_POST_DELAY = exports.START_MARK_POST_DELAY = 'embed-script-start-post-delay';
const END_MARK_POST_DELAY = exports.END_MARK_POST_DELAY = 'embed-script-end-post-delay';
const EXECUTION_MEASUREMENT_POST_DELAY = exports.EXECUTION_MEASUREMENT_POST_DELAY = 'embed-script-load-time-post-delay';
const EXECUTION_MEASUREMENT_PRE_DELAY = exports.EXECUTION_MEASUREMENT_PRE_DELAY = 'embed-script-load-time-pre-delay';